import MediaList from './MediaList'

function SearchResults({
  searchResults,
  loadingQueueActions,
  isInQueue,
  handleAddToQueue,
  handleRemoveFromQueue,
  handleRemoveFromCollection,
  handleAddToCollage,
  handleMoveToCollection,
  loadingNotes,
  loadingRecs,
}) {
  console.log('SearchResults component received:', searchResults)

  if (!searchResults) {
    return <div className='search-results'></div>
  }

  const renderSection = (title, items, type) => {
    if (!items || items.length === 0) return null

    return (
      <div className='search-section'>
        <h3>{title}</h3>
        <MediaList
          mediaItems={items}
          type={type === 'queue' ? items[0]?.media_type : type}
          loadingQueueActions={loadingQueueActions}
          isInQueue={isInQueue}
          onAddToQueue={handleAddToQueue}
          onRemoveFromQueue={handleRemoveFromQueue}
          onRemoveFromCollection={handleRemoveFromCollection}
          onAddToCollage={handleAddToCollage}
        />
      </div>
    )
  }

  const renderNotesSection = (items) => {
    if (!items || items.length === 0) return null

    return (
      <div className='search-section'>
        <h3>Notes</h3>
        {loadingNotes ? (
          <p>Loading notes...</p>
        ) : (
          <MediaList
            mediaItems={items}
            type='notes'
            loadingQueueActions={loadingQueueActions}
            isInQueue={isInQueue}
            onAddToQueue={handleAddToQueue}
            onRemoveFromQueue={handleRemoveFromQueue}
            onRemoveFromCollection={handleRemoveFromCollection}
            onAddToCollage={handleAddToCollage}
            showNoteText={true}
          />
        )}
      </div>
    )
  }

  const renderRecsSection = (items) => {
    if (!items || items.length === 0) return null

    return (
      <div className='search-section'>
        <h3>Recommendations</h3>
        {loadingRecs ? (
          <p>Loading recommendations...</p>
        ) : (
          <MediaList
            mediaItems={items}
            type='recs'
            loadingQueueActions={loadingQueueActions}
            isInQueue={isInQueue}
            onAddToQueue={handleAddToQueue}
            onRemoveFromQueue={handleRemoveFromQueue}
            onRemoveFromCollection={handleRemoveFromCollection}
            onAddToCollage={handleAddToCollage}
            showRecInfo={true}
          />
        )}
      </div>
    )
  }

  return (
    <div className='search-results'>
      {renderSection('Queue', searchResults.queue, 'queue')}
      {renderSection('Songs', searchResults.songs, 'song')}
      {renderSection('Albums', searchResults.albums, 'album')}
      {renderSection('Playlists', searchResults.playlists, 'playlist')}
      {renderSection('Mixes', searchResults.mixes, 'mix')}
      {renderSection('Collages', searchResults.collages, 'collage')}
      {renderNotesSection(searchResults.notes)}
      {renderRecsSection(searchResults.recs)}
    </div>
  )
}

export default SearchResults
